module.exports = __webpack_public_path__ + "static/food-truk-c138f6cc2c2e838c689ea4d280e9e911.png";